module.exports = __webpack_public_path__ + "img/bird-watching.f71975f3.jpg";